import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { collect } from 'collect.js';
import { Button, Card, Form } from 'antd';
import useApiClient from '../../../hooks/api/useApiClient';
import CompanySelect from '../../../components/form/business/CompanySelect';
import { ManagerRole } from '../../../hooks/auth/usePermissions';

export default function AccessControlListTab() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Team:Managers:AccessControlListTab' });

  const { ManagersManager } = useApiClient();

  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const [accessControlList, setAccessControlList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    loadAccessControlList();
  }, [serviceProvider?.id]);

  const loadAccessControlList = async () => {
    setLoading(true);
    const { success, data: responseData } = await ManagersManager.getGlobalAccessControlList({
      role: ManagerRole.Reseller,
    });
    setLoading(false);

    if (!success) {
      return toast.error(t('toasts.failed_to_load_data'));
    }

    setAccessControlList(responseData);
  };

  const updateAccessControlList = async () => {
    setUpdating(true);
    const { success } = await ManagersManager.updateGlobalAccessControlList({
      role: ManagerRole.Reseller,
      company_uuids: collect(accessControlList).pluck('uuid').toArray(),
    });
    setUpdating(false);

    if (!success) {
      return toast.error(t('toasts.failed_to_save_changes'));
    }

    return toast.success(t('toasts.changes_got_saved'));
  };

  return (
    <div>
      <Card
        title={t('title', { role: ManagerRole.Reseller })}
        loading={loading}
        extra={
          <Button loading={updating} onClick={updateAccessControlList} type="primary">
            {t('buttons.save')}
          </Button>
        }
      >
        <Form layout="vertical">
          <Form.Item
            label={t('form.companies.label', { role: ManagerRole.Reseller })}
            tooltip={t('form.companies.tooltip', { role: ManagerRole.Reseller })}
          >
            <CompanySelect value={accessControlList} onChange={setAccessControlList} isMulti />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
